import * as lists from "./MockList"

let newList = [];

Object.keys(lists).forEach(key => {
  const value = lists[key];
  newList = newList.concat(value);
})

export default newList;